import React, { useMemo, useState } from "react";
import { Select, Spin } from "antd";
import debounce from "lodash.debounce";
import reapi from "../apis/reapi";

export default function CategorySearch({ onSelectCategory }) {
    const [categories, setCategories] = useState([]);
    const [SelectedCategory, setSelectedCategory] = useState(null);

    const [fetching, setFetching] = useState(false);

    // console.log(SelectedCategory)

    const searchCategories = async (searchText) => {
        if (!searchText || searchText?.length < 4) {
            setCategories([]);
            return;
        }

        setFetching(true);

        try {
            const res = await reapi.get("/searchcategory", {
                params: { q: searchText },
            });

            setCategories(
                res.data.data?.data?.map((item) => ({
                    label: item.name || item.catalog_name || item.category_name,
                    value: item.id || item.catalog_id || item.category_id,
                    data: item,
                })) || []
            );
        } catch (error) {
            console.error("Category search failed", error);
        } finally {
            setFetching(false);
        }
    };

    const debouncedSearch = useMemo(
        () => debounce(searchCategories, 500),
        []
    );

    return (
        <Select
            showSearch
            allowClear
            placeholder="Search Category"
            className="w-full h-12 mb-5"
            filterOption={false}
            onSearch={debouncedSearch}
            options={categories}
            notFoundContent={fetching ? "Loading..." : "Type 4 letters to search"}
            optionRender={(option) => {
                const item = option.data.data;
                const mainCategory = item.chain?.[0] || "";
                const path = item.chain?.join(" > ");

                return (
                    <div className="py-2">
                        <div className="text-[15px] font-semibold text-slate-900">
                            {item.name}{" "}
                            <span className="font-normal text-slate-700">
                                in {mainCategory}
                            </span>
                        </div>

                        <div className="text-xs text-slate-500 mt-1 whitespace-normal leading-5">
                            {path}
                        </div>
                    </div>
                );
            }}
            onChange={(value, option) => {
                setSelectedCategory(option?.data);
                onSelectCategory(option?.data)
            }}
        />
    );
}